import { useState, useEffect } from 'react'
import { View, RView } from 'components/View/'
import { useRecoilValueLoadable } from 'recoil'
import fetchUsers from 'stores/UserList'
import { IUserType } from 'types'

import UserItem from 'components/UserItem/'
import { Input } from 'antd'
import { SearchOutlined } from '@ant-design/icons'
import { Link } from 'react-router-dom'
import styles from './index.module.css'

export default function UserList () {
  const [usersMap, setUsers] = useState([])
  const [filterText, setFilterText] = useState('')
  const users = useRecoilValueLoadable(fetchUsers)

  useEffect(() => {
    if (users.state !== 'hasValue') return
    setUsers(users.contents)
  }, [users.contents, users.state])

  useEffect(() => {
    if (users.state !== 'hasValue') return
    const text = filterText.toLowerCase()
    if (!text) {
      setUsers(users.contents)
    }
    const userMap = users.contents.filter(
      (user: any) =>
        user.name.toLowerCase().includes(text) ||
        user.email.toLowerCase().includes(text) ||
        user.phone.toLowerCase().includes(text) ||
        user.website.toLowerCase().includes(text)
    )

    setUsers(userMap)
  }, [filterText])

  if (users.state === 'loading') return <div>Loading...</div>
  // if (userName.state === 'loading') return <div>Loading...</div>

  return (
    <View>
      <RView flex center>
        <RView className={styles.inputContainer}>
          <Input
            size='large'
            onChange={e => setFilterText(e.target.value)}
            placeholder='Search for users'
            prefix={<SearchOutlined />}
          />
        </RView>
        <Link to='/favorites'>Show Favorites</Link>
      </RView>

      <RView style={{ justifyContent: 'center', flexWrap: 'wrap' }}>
        {usersMap?.map((user: IUserType) => (
          <UserItem key={user.id} {...user} filterText={filterText} />
        ))}
      </RView>
    </View>
  )
}
